import React, { useState, useEffect } from 'react';

const AdminPanel = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [password, setPassword] = useState('');
    const [products, setProducts] = useState([]);
    const [newProduct, setNewProduct] = useState({
        name: '',
        description: '',
        price: '',
        image: '',
        category: 'Plumbing'
    });

    // Admin password - CHANGE THIS!
    const ADMIN_PASSWORD = "kassim123";

    useEffect(() => {
        // Load products from localStorage when component mounts
        const savedProducts = JSON.parse(localStorage.getItem('kassim-products')) || [];
        setProducts(savedProducts);
    }, []);

    const handleLogin = (e) => {
        e.preventDefault();
        if (password === ADMIN_PASSWORD) {
            setIsAuthenticated(true);
        } else {
            alert('Wrong password! Please try again.');
        }
    };

    const handleInputChange = (e) => {
        setNewProduct({
            ...newProduct,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const productToAdd = {
            ...newProduct,
            id: Date.now(), // Unique ID
            originalPrice: '', // For compatibility with your existing structure
            code: `PROD-${Date.now()}`,
            rating: 4.5,
            reviews: Math.floor(Math.random() * 100) + 50
        };

        const updatedProducts = [...products, productToAdd];
        setProducts(updatedProducts);
        localStorage.setItem('kassim-products', JSON.stringify(updatedProducts));
        
        alert('✅ Product saved successfully!');
        setNewProduct({ name: '', description: '', price: '', image: '', category: 'Plumbing' });
    };

    const deleteProduct = (productId) => {
        if (window.confirm('Are you sure you want to delete this product?')) {
            const updatedProducts = products.filter(product => product.id !== productId);
            setProducts(updatedProducts);
            localStorage.setItem('kassim-products', JSON.stringify(updatedProducts));
            alert('Product deleted successfully!');
        }
    };

    if (!isAuthenticated) {
        return (
            <div className="container mt-5">
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <div className="card">
                            <div className="card-body">
                                <h3 className="card-title text-center">🔐 Admin Login</h3>
                                <form onSubmit={handleLogin}>
                                    <div className="mb-3">
                                        <label className="form-label">Enter Admin Password:</label>
                                        <input 
                                            type="password" 
                                            className="form-control" 
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required 
                                        />
                                    </div>
                                    <button type="submit" className="btn btn-primary w-100">
                                        Access Admin Panel
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container mt-4">
            <div className="admin-container bg-white p-4 rounded shadow-sm">
                <h2 className="text-center mb-4">📦 Product Management</h2>
                
                {/* Add Product Form */}
                <form onSubmit={handleSubmit} className="mb-5 p-3 border rounded">
                    <h4>Add New Product</h4>
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <label className="form-label">Product Name *</label>
                            <input 
                                type="text" 
                                name="name"
                                className="form-control" 
                                value={newProduct.name}
                                onChange={handleInputChange}
                                required 
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label">Price *</label>
                            <input 
                                type="text" 
                                name="price"
                                className="form-control" 
                                value={newProduct.price}
                                onChange={handleInputChange}
                                placeholder="e.g., KSH 1,500" 
                                required 
                            />
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <label className="form-label">Category *</label>
                            <select 
                                name="category"
                                className="form-control" 
                                value={newProduct.category}
                                onChange={handleInputChange}
                                required
                            >
                                <option value="Plumbing">Plumbing</option>
                                <option value="Electrical">Electrical</option>
                                <option value="Tools">Tools</option>
                                <option value="Pipes">Pipes</option>
                                <option value="Fittings">Fittings</option>
                                <option value="Lighting">Lighting</option>
                            </select>
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label">Image URL *</label>
                            <input 
                                type="text" 
                                name="image"
                                className="form-control" 
                                value={newProduct.image}
                                onChange={handleInputChange}
                                placeholder="https://example.com/image.jpg" 
                                required 
                            />
                        </div>
                    </div>
                    
                    <div className="mb-3">
                        <label className="form-label">Description *</label>
                        <textarea 
                            name="description"
                            className="form-control" 
                            rows="3" 
                            value={newProduct.description}
                            onChange={handleInputChange}
                            required
                        ></textarea>
                    </div>

                    {newProduct.image && (
                        <div className="mb-3">
                            <label className="form-label">Image Preview:</label>
                            <div className="mt-2">
                                <img 
                                    src={newProduct.image} 
                                    alt="Preview" 
                                    className="img-fluid rounded"
                                    style={{maxHeight: '150px', maxWidth: '200px'}}
                                    onError={(e) => {
                                        e.target.style.display = 'none';
                                    }}
                                />
                            </div>
                        </div>
                    )}

                    <button type="submit" className="btn btn-success me-2">💾 Save Product</button>
                    <button 
                        type="button" 
                        className="btn btn-secondary"
                        onClick={() => setNewProduct({ name: '', description: '', price: '', image: '', category: 'Plumbing' })}
                    >
                        🔄 Clear Form
                    </button>
                </form>

                <hr />

                {/* Existing Products List */}
                <div>
                    <h4>Existing Products ({products.length})</h4>
                    {products.length === 0 ? (
                        <p className="text-muted">No products added yet.</p>
                    ) : (
                        <div className="row">
                            {products.map(product => (
                                <div key={product.id} className="col-md-6 mb-3">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-4">
                                                    <img 
                                                        src={product.image} 
                                                        className="img-fluid rounded" 
                                                        alt={product.name}
                                                        style={{height: '80px', objectFit: 'cover', width: '100%'}}
                                                        onError={(e) => {
                                                            e.target.src = 'https://via.placeholder.com/80x80?text=No+Image';
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-8">
                                                    <h6 className="card-title">{product.name}</h6>
                                                    <p className="card-text small text-muted">
                                                        {product.description.substring(0, 50)}...
                                                    </p>
                                                    <p className="card-text">
                                                        <strong>{product.price}</strong>
                                                        <span className="badge bg-secondary ms-2">{product.category}</span>
                                                    </p>
                                                    <button 
                                                        onClick={() => deleteProduct(product.id)}
                                                        className="btn btn-danger btn-sm"
                                                    >
                                                        Delete
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AdminPanel;
